import * as React from 'react';
import { Icon } from '../Icon';
import { GoogleButton, FacebookButton } from './styles';
interface AuthButtonProps {
  providerType: 'facebook' | 'google';
  authType: 'login' | 'signup';
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
}

export const AuthButton: React.SFC<AuthButtonProps> = ({ providerType, authType, onClick }) => {
  if (providerType === 'google') {
    return (
      <GoogleButton onClick={onClick} data-provider={providerType}>
        <Icon type={providerType} />
      </GoogleButton>
    );
  } else {
    return (
      <FacebookButton onClick={onClick} data-provider={providerType}>
        <Icon type={providerType} />
      </FacebookButton>
    );
  }
};
